<template>
  <div>
    <div class="titlePage mb-3">Solicitações da Divulgação de Gabaritos e Provas</div>
    <fcc-table
      v-if="idNotificacao == 0"
      striped
      hover
      :fields="fieldsGabarito"
      :items="lstSolicitante"
      :actions="actionsGabarito"
      responsive
      :titlePage="titlePage"
      :titlePDF="titlePage"
      :por-page="'100'"
      pagination
    />
    <fcc-lista-gabarito
      v-else
      @zerarSolicitacao="zerarSolicitacao"
      :idNotificacao="idNotificacao"
      :controlePage="controlePage"
    />
  </div>
</template>
<script>
import fccListaGabarito from './fccListaGabaritos.vue'
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      titlePage: 'Gabaritos e Provas',
      idNotificacao: 0,
      lstSolicitante: [],
      actionsGabarito: [
        {
          button: true,
          funcaoButton: 'visualizaSolicitacao',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      fieldsGabarito: [
        { key: 'numero', label: 'Nº', sortable: true },
        { key: 'tipopublicacao', label: 'Tipo de Publicação	', sortable: true },
        { key: 'solicitante', label: 'Solicitante', sortable: true },
        { key: 'datasolicitacao', label: 'Data de Solicitação' },
        { key: 'datapublicacao', label: 'Data de Publicação' },
        { key: 'tecniconapd', label: 'Técnico NAPD' },
        { key: 'sgp', label: 'SGP' },
        // { key: 'importacao', label: 'Importação' },
        { key: 'situacao', label: 'Status' }
      ]
    }
  },
  components: { fccListaGabarito },
  props: {
    controlePage: Object
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.listarSolicitante()
  },
  methods: {
    zerarSolicitacao(number) {
      this.idNotificacao = number
    },
    visualizaSolicitacao(_, item) {
      this.idNotificacao = item.numero
    },
    listarSolicitante() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao + `PublicacaoGabarito/ListarSolicitante/${this.controlePage.spi}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstSolicitante = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  }
}
</script>